import AddInsPage from '../AddInsPage';
import { Button } from '@prio365/prio365-react-library';
import { useTranslation } from 'react-i18next';
import { makePrioStyles } from '../../../../theme/utils';
import { useState } from 'react';

const useStyles = makePrioStyles((theme) => ({
  root: {
    width: '100%',
  },
  submitButtonFormItem: {
    textAlign: 'right',
  },
  wrapContainerWhite: {
    backgroundColor: theme.old.palette.backgroundPalette.content,
    padding: `${theme.old.spacing.unit(2)}px ${theme.old.spacing.unit(2)}px`,
    marginBottom: `${theme.old.spacing.unit(2)}px`,
    overflow: 'hidden',
    minHeight: `${theme.old.spacing.unit(8)}px`,
  },
  wrapContainerWhiteMain: {
    overflow: 'hidden',
    height: '100%',
  },
  contentContainerFloat: {
    gap: `${theme.old.spacing.unit(2)}px`,
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    overflow: 'hidden',
    '& .ant-form-item': {
      width: '100%',
    },
    '& .ant-row': {
      width: '100%',
    },
  },
  contentContainer: {
    backgroundColor: theme.old.palette.backgroundPalette.sub,
    gap: `${theme.old.spacing.unit(2)}px`,
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    position: 'relative',
    height: '100%',
    overflow: 'hidden',
  },
  spacing: {
    marginLeft: theme.old.spacing.unit(2),
  },
  floatRight: {
    float: 'right',
  },
}));

interface CreateProjectAddInFormProps {
  className?: string;
  projectId: string;
  nextStep?: (projectId: string, step: string) => void;
}

export const CreateProjectAddInForm: React.FC<CreateProjectAddInFormProps> = (
  props
) => {
  const classes = useStyles();
  const { nextStep, projectId } = props;
  const { t } = useTranslation();
  const [noExtensionsModalVisible, setnoExtensionsModalVisible] =
    useState<boolean>(false);

  const handleOpenNoExtensionsModal = (): void => {
    setnoExtensionsModalVisible(true);
  };

  const handleCancelNoExtensionsModal = (): void => {
    setnoExtensionsModalVisible(false);
    if (nextStep) nextStep(projectId, 'summary');
  };

  return (
    <>
      <div className={classes.contentContainer}>
        <div className={classes.wrapContainerWhiteMain}>
          <AddInsPage
            projectId={projectId}
            withNoExtensionsModal={true}
            noExtensionsModalVisible={noExtensionsModalVisible}
            setNoExtensionsModalVisible={setnoExtensionsModalVisible}
            handleCancelNoExtensionsModal={handleCancelNoExtensionsModal}
          />
        </div>
        <div className={classes.wrapContainerWhite}>
          <Button
            type="primary"
            className={classes.floatRight}
            onClick={() => {
              !noExtensionsModalVisible
                ? handleOpenNoExtensionsModal()
                : nextStep(projectId, 'summary');
            }}
          >
            {t('projects:createProject.buttons.next')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default CreateProjectAddInForm;
